/**
 * validateCPF.ts
 * Validação algorítmica de CPF (módulo 11)
 * - Remove máscara
 * - Rejeita sequências repetidas (111...)
 * - Calcula dígitos verificadores
 */

export function isValidCPF(input: string): boolean {
  const cleaned = (input || '').replace(/\D/g, '');
  if (cleaned.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cleaned)) return false; // 000... / 111... etc

  // Primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned[i], 10) * (10 - i);
  }
  let d1 = (sum * 10) % 11;
  if (d1 === 10) d1 = 0;

  // Segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleaned[i], 10) * (11 - i);
  }
  let d2 = (sum * 10) % 11;
  if (d2 === 10) d2 = 0;

  return cleaned[9] === String(d1) && cleaned[10] === String(d2);
}
